import * as React from 'react';
import classnames from 'classnames';

import FormRequiredMark from '../form-required-mark/FormRequiredMark';

import './form-group.scss';

type Props = {
  title: string,
  message?: string,
  position?: 'normal' | 'overlap',
  width?: 'normal' | 'full',
  children: React.ReactNode,
  showRequiredMark: boolean,
  hideBorder?: boolean
};

class FormGroup extends React.PureComponent<Props> {
  static defaultProps = {
    showRequiredMark: false
  };

  render(): React.ReactNode {
    const { title, message, children, position, width, showRequiredMark, hideBorder } = this.props;

    const groupClasses = classnames({
      'form-group': true,
      'form-group--no-border': hideBorder,
      [`form-group--position-${position || 'normal'}`]: position,
      [`form-group--width-${width || 'normal'}`]: width,
      'form-group--has-title': title
    });

    return (
      <fieldset className={groupClasses}>
        {
          title &&
            <div className="form-group__title">
              {title}
              {
                showRequiredMark &&
                  <FormRequiredMark />
              }
            </div>
        }
        {
          message &&
            <div className="form-group__message">
              {message}
            </div>
        }
        {children}
      </fieldset>
    );
  }
}

export default FormGroup;
